import api from "src/services/api";
import {
  getMergedModulePermissions,
  loadModulePermissions,
  ModulePermissionsMap,
  saveModulePermissions,
} from "src/config/modulePermissions";

const fromApi = (data: any): ModulePermissionsMap => {
  return getMergedModulePermissions(data || {});
};

export const obtenerPermisosModulos = async (): Promise<ModulePermissionsMap> => {
  const { data } = await api.get<{ permisos?: any }>("inicio/module-permissions");
  return fromApi(data?.permisos || {});
};

export const actualizarPermisosModulos = async (
  permisos: ModulePermissionsMap
): Promise<ModulePermissionsMap> => {
  const { data } = await api.put<{ permisos?: any }>("inicio/module-permissions", {
    permisos,
  });
  return fromApi(data?.permisos || {});
};

export const actualizarPermisosModulo = async (
  moduleId: string,
  cargos: Record<string, boolean>
): Promise<ModulePermissionsMap> => {
  const { data } = await api.put<{ permisos?: any }>("inicio/module-permissions", {
    module_id: String(moduleId || "").trim().toLowerCase(),
    cargos,
  });
  return fromApi(data?.permisos || {});
};

export const sincronizarPermisosModulos = async (): Promise<ModulePermissionsMap> => {
  try {
    const remotos = await obtenerPermisosModulos();
    saveModulePermissions(remotos);
    return remotos;
  } catch {
    return loadModulePermissions();
  }
};
